import { useLexicalComposerContext } from "@lexical/react/LexicalComposerContext";
import { $createTextNode, $getRoot, $isTextNode } from "lexical";
import { useEffect } from "react";
import { extractSurveyUrl } from "../components/utils/survey-url";
import { useLexicalContext } from "../lexical-context";
import { $createSurveyLinkNode } from "../nodes/survey-link-node";
import { $findAllNodesOfType } from "../utils/find-all-nodes-of-type";

export const FixSmsSurveyLinkPlugin = (): null => {
  const [editor] = useLexicalComposerContext();
  const { format } = useLexicalContext();

  useEffect(() => {
    if (format !== "sms") return;

    editor.update(() => {
      const textNodes = $findAllNodesOfType($getRoot(), $isTextNode);

      textNodes.forEach((textNode) => {
        const text = textNode.getTextContent();
        const surveyUrl = extractSurveyUrl(text);
        if (!surveyUrl) return;

        const parts = text.split(surveyUrl);
        const newNodes = [];

        if (parts[0]) newNodes.push($createTextNode(parts[0]));
        newNodes.push($createSurveyLinkNode(surveyUrl).append($createTextNode("survey_link")));
        if (parts[1]) newNodes.push($createTextNode(parts[1]));

        const [node] = newNodes;
        if (!node) return;

        textNode.replace(node);
        let prevNode = node;
        newNodes.slice(1).forEach((newNode) => {
          prevNode.insertAfter(newNode);
          prevNode = newNode;
        });
      });
    });
  }, [editor, format]);

  return null;
};
